import { useTranslation } from "react-i18next";

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16">
        <div className="w-full md:w-[40%]">
          <div className="w-full aspect-[4/5] rounded-[32px] overflow-hidden bg-accent-100">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20business%20person%20in%20modern%20office%20reviewing%20spreadsheet%20on%20laptop%20with%20product%20samples%20nearby%20confident%20expression%20clean%20minimalist%20background%20soft%20natural%20lighting%20editorial%20style&width=600&height=750&seq=trust-person-img&orientation=portrait"
              alt="Expert review"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="w-full md:w-[60%]">
          <p className="text-sm text-foreground-500 font-medium mb-4">
            {t("trust_label")}
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-8">
            {t("trust_title_line1")}{" "}
            <span className="text-foreground-400">{t("trust_title_line2")}</span>
          </h2>
          <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8 pl-6 border-l-2 border-primary-300">
            &laquo;{t("trust_quote")}&raquo;
          </blockquote>
          <div className="flex items-center gap-3">
            <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{t("trust_author")}</p>
              <p className="text-xs text-foreground-500">{t("trust_role")}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 mt-8">
            <button className="w-10 h-10 rounded-full border-2 border-secondary-300 flex items-center justify-center text-secondary-500 cursor-pointer hover:border-secondary-500 transition-colors">
              <i className="ri-arrow-left-line"></i>
            </button>
            <button className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center text-background-50 cursor-pointer hover:bg-primary-600 transition-colors">
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}